export default __webpack_public_path__ + "static/media/assetHeaderLeft.d21157fd.PNG";